import React from 'react';
import { qhseBg, services21, services22, services23, servicesPrez21, servicesPrez210, servicesPrez211, servicesPrez212, servicesPrez213, servicesPrez214, servicesPrez215, servicesPrez218, servicesPrez219, servicesPrez22, servicesPrez23, servicesPrez24, servicesPrez25, servicesPrez26, servicesPrez28, servicesPrez29} from '../../../../assets/images';
import { useTranslation } from 'react-i18next';
import SubOtherHero from '../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero';

const Geological = () => {
  const { t } = useTranslation();

  return (
    <> 
      <div
        className='bg-black/60'
        style={{
          position: 'relative',
          overflow: 'hidden',
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: 'cover', 
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          height: window.innerWidth < 640 ? '200px' : '300px',
        }}
      >
        <SubOtherHero title="Geological Intelligence for Drilling: Powered by Advanced Software" />
      </div>

      <div className="bg-[#EDEDED] py-10 md:py-20">
        
        <div className="md:max-w-container max-w-containerSm mx-auto ">
          {/* Main Text */} 
             <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {t('Geological Intelligence for Drilling: Powered by Advanced Software')}
            </p>
             <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t('Caspian Rock Solutions, a proud member of the Caspian Rock Solutions group, is the official distributor of GeoGraphix software and LMKR services in Azerbaijan. Through our partnership with LMKR, we provide a full suite of GeoGraphix programs alongside expert consulting services tailored to exploration and production needs.')}
            </p>
             <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t('GeoGraphix software delivers unparalleled capabilities for seismic data interpretation, ensuring exceptional results with intuitive usability. It offers a cost-effective and competitive solution for all seismic exploration challenges.')}
            </p>
             <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t('Beyond software distribution, we specialize in comprehensive data management, digitalization solutions, and workflow optimization. These services empower clients with advanced tools for data-driven decision-making, ensuring operational efficiency and innovation in exploration and production projects.')}
            </p>
            {/* HPU */}
          <div className='md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row mt-10'>
            <div className="md:w-1/2 gap-4">
                      <img src={services21} alt="Drill Bit 1" className="w-full rounded-lg shadow-md" />
                    </div>

          {/* Right Image */}
           <div className="md:w-1/2 gap-4 mt-8 md:mt-0">
                      <img src={services22} alt="Drill Bit 1" className="w-full rounded-lg shadow-md" />
                    </div>
          </div>
           <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B] mb-5">
              {t('Below, it is possible to find some the most important module names and powerful information for GGX.')}
            </p>
 <div className='grid grid-cols-2 md:grid-cols-4 gap-5'>
   <a 
  href={servicesPrez22} 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors"
>
  {t("Gverse geology")}
</a>
  <a 
  href="https://www.youtube.com/watch?v=QGykV-U14Gs" 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors"
>
  {t("Isomap")}
</a>
  <a 
  href="https://www.youtube.com/watch?v=qFt_Kp9YM38" 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors"
>
  {t("LogM Advanced")}
</a>
  <a 
  href={servicesPrez23} 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors"
>
  {t("Petrophysics")}
</a>
<a 
  href={servicesPrez25} 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors"
>
  {t("Seismic interpretation")}
</a>
  <a 
  href={servicesPrez26} 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors"
>
  {t("smartSection")}
</a>
  <a 
  href="https://www.youtube.com/watch?v=dLUSaF3RwkE" 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors"
>
  {t("LogM Advanced")}
</a>
  <a 
  href={servicesPrez24} 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors"
>
  {t("Geomodeling")}
</a>
<a 
  href={servicesPrez28} 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors"
>
  {t("Leasemap")}
</a>
  <a 
  href={servicesPrez29} 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors"
>
  {t("Seisvision")}
</a>
  <a 
  href={servicesPrez210} 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors"
>
  {t("Field planner")}
</a>
  <a 
   href={servicesPrez211} 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors"
>
  {t("Websteering")}
</a>
<a 
  href={servicesPrez212} 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors"
>
  {t("Connect")}
</a>
  <a 
    href={servicesPrez213} 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors"
>
  {t("Gverse Geophysics")}
</a>
  <a 
  href="https://gverse.com/ProductPackages/WellPlanner" 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors "
>
  {t("Well planner")}
</a>
  <a 
    href={servicesPrez214} 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors "
>
  {t("smartSTART")}
</a>
<a 
   href={servicesPrez215} 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors "
>
  {t("Geoatlas")}
</a>
  <a 
    href={servicesPrez218} 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors"
>
  {t("Gverse Attributes")}
</a>
  <a 
    href={servicesPrez219} 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors"
>
  {t("Prizm")}
</a>
 </div>
                       <a 
  href={`${servicesPrez21}`} 
  target="_blank" 
  rel="noopener noreferrer" 
  className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors mt-5"
>
  {t("To learn more please download GGX_Caspian Rock Solutions presentation.pptx")}
</a>
             {/* BMS */}
            <div className='md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row mt-10'>
            <div className="md:w-1/2">
          

                        <p className="mt-6 text-[20px] font-semibold text-[#141615]">
              {t('Digitalization Project Overview: Transforming Data with Caspian Rock Solutions and LMKR')}
            </p>

 <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t('Caspian Rock Solutions, in partnership with LMKR, successfully executed a transformative digitalization project to address the challenge of managing extensive hard copy data, including reports, well logs, and other critical documents. This initiative involved meticulously scanning, indexing, and organizing physical records into a fully digital format.')}
            </p>
            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t('The result was not just a digitized archive but a more streamlined and user-friendly system designed for efficient access and analysis. This enhanced digital solution improves data utilization, fosters better decision-making, and boosts operational efficiency.')}
            </p>
            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t("By leveraging Caspian Rock Solutions's local expertise and LMKR's advanced technological capabilities, we developed a modernized and centralized data management system. This project was successfully implemented for GL TOC, equipping them with a reliable and innovative platform to enhance their exploration and production activities.")}
            </p>

          </div>

          {/* Right Image */}
           <div className="md:w-1/2 mt-8 md:mt-0">
                      <img src={services23} alt="Drill Bit 1" className="w-full rounded-lg shadow-md" />
                    </div>
          </div>
             {/* Customers */}
           <div className='md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row mt-10'>
            <div>
          </div>
          </div>
        </div>
      </div>
    </>
  );
}; 

export default Geological;
